var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown dropdown-hover"},[_c('router-link',{attrs:{"to":{name: 'ShoppingCart'}}},[_c('span',[_c('i',{staticClass:"icon nav-cart"})]),_vm._v(" "),_c('span',{staticClass:"label label-success label-count",attrs:{"id":"shoppingCartCount"}},[_vm._v(_vm._s(_vm.cartSummary.ItemCount))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }